// Satu sumber kebenaran utk aturan kompleksitas password baru di frontend --
// dipakai bareng oleh PasswordRequirements.jsx (checklist real-time) dan tiap
// form/dialog yg submit password (Users.jsx, BulkCreateAdminDialog.jsx,
// ForcePasswordChange.jsx, ResetPassword.jsx) supaya validasi client-side
// konsisten. Backend (validate_password_complexity di server.py) TETAP jadi
// penjaga sesungguhnya -- ini cuma feedback dini buat user.
export const PASSWORD_MIN_LENGTH = 8;
// Cermin PASSWORD_MAX_BYTES di server.py: bcrypt hanya memakai 72 BYTE (UTF-8)
// pertama. Huruf/angka/simbol biasa = 1 byte; huruf beraksen/emoji = 2-4 byte.
export const PASSWORD_MAX_BYTES = 72;
const panjangByte = (pw) => new TextEncoder().encode(pw).length;

export const PASSWORD_RULES = [
    { key: "length", label: `Minimal ${PASSWORD_MIN_LENGTH} karakter`, test: (pw) => pw.length >= PASSWORD_MIN_LENGTH },
    { key: "upper", label: "Minimal 1 huruf besar (A-Z)", test: (pw) => /[A-Z]/.test(pw) },
    { key: "lower", label: "Minimal 1 huruf kecil (a-z)", test: (pw) => /[a-z]/.test(pw) },
    { key: "digit", label: "Minimal 1 angka (0-9)", test: (pw) => /[0-9]/.test(pw) },
    { key: "symbol", label: "Minimal 1 simbol (bukan huruf/angka)", test: (pw) => /[^A-Za-z0-9]/.test(pw) },
    { key: "max", label: `Maksimal ${PASSWORD_MAX_BYTES} karakter biasa (huruf beraksen/emoji dihitung 2-4)`, test: (pw) => panjangByte(pw) <= PASSWORD_MAX_BYTES },
];

export const isPasswordValid = (pw) => PASSWORD_RULES.every((r) => r.test(pw || ""));
